import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractPaginator } from '../../utils/pagination/abstract-paginator';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  standalone: false
})
export class PaginatorComponent {

  @Input()
  public pages: AbstractPaginator;

  @Output()
  public page = new EventEmitter();

  public next(): void {
    this.pages.next();
    this.page.emit();
  }

  public previous(): void {
    this.pages.previous();
    this.page.emit();
  }
}
